import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl, loggedUser, sendWhatsAppMessage } from "../../../Utility/constants";
import AdminHeader from "../../common/AdminHeader";
import Footer from "../../common/Footer";
import "./PersonalDetails.css";
import EditPersonalDetailsModal from "./EditPersonalDetailsModal";
import PersonalDetailsList from "./PersonalDetailsList";
import AddNewStudentModal from "./AddNewStudentModal";
import AddStudentOtherDetailsModal from "./AddStudentOtherDetailsModal";
import StudentDetailsModal from "./StudentDetailsModal";
import DocumentMasterModal from "./DocumentMasterModal";
import SchoolLeavingCertificateModal from "./SchoolLeavingCertificateModal";
import { Toast } from "bootstrap";
import { getSchoolId } from "../../../Utility/commonFunctions";

const PersonalDetailsPage = () => {
  const role = localStorage.getItem("Role");
  const [data, setData] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showOtherDetailsEditModal, setShowOtherDetailsModal] = useState(false);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [greetingMessage, setGreetingMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showOneTimeModal, setShowOneTimeModal] = useState(false);
  const [studentDetails, setStudentDetails] = useState(null);
  const [adminSelectedSchoolId, setAdminSelectedSchoolId] = useState(null);
  const [schoolWebsiteLink, setSchoolWebsiteLink] = useState(null);
  const [schoolOrCollegeName, setSchoolOrCollegeName] = useState(null);
  const [showSLCModal, setShowSLCModal] = useState(false);
  const [schoolLeavingCertificateData, setSchoolLeavingCertificateData] = useState(null);
  const loggedUser = localStorage.getItem("userID");
  const [studentId, setStudentId] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    studentContactNumber: "",
    uIDNo: "",
    password: "",
    schoolName: "",
    sessionId: "",
    schoolId: adminSelectedSchoolId,
    StandardId: "",
    SectionId: "",
  });

  const defaultHideFields = {
    hideFirstName: false,
    hideMiddleName: false,
    hideLastName: false,
    hideMotherName: false,
    hideReligion: false,
    hideCaste: false,
    hideCategory: false,
    hideNationality: false,
    hideMotherTongue: false,
    hideBirthPlace: false
  };

  useEffect(() => {
    fetchAdminSchoolId();
    fetchData();
    fetchAdminData();
  }, []);

  const fetchAdminSchoolId = async () => {
    const schoolId = await getSchoolId();
    setAdminSelectedSchoolId(schoolId);
  };

  const fetchData = async () => {

    
    const userId = localStorage.getItem("userID");

    const endpoints = {
      SUPERADMIN: `${baseUrl}/api/PersonalDetails`,
      ADMIN: `${baseUrl}/api/PersonalDetails/PersonalDetailsByAdmin?AdminId=${userId}`,
      TEACHER: `${baseUrl}/api/PersonalDetails/PersonalDetailsByTeacherId?TeacherId=${userId}`,
      STUDENT: `${baseUrl}/api/PersonalDetails/PersonalDetailsByStudent?StudentId=${localStorage.getItem("userID")}`
    };

    const url = endpoints[role] || "";
    try {

      const response = await axios.get(url);
      if (response && response.data && response.data && response.data.length > 0) {
        setData(response.data);
        setStudentId(response.data[0]?.studentId);
        if (response.data[0]?.isInitialMessage === 0) {
          setShowOneTimeModal(true); // Show the popup
        }
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const fetchAdminData = async () => {
    try {
      const school_Id = await getSchoolId();
      const url = `${baseUrl}/api/Admin/GetSchoolDetails?id=${school_Id}`;
      const response = await axios.get(url);
      if (response && response.data && response.data) {
        //setAdminSelectedSchoolId(response.data.admin.schoolId);
        setSchoolWebsiteLink(response.data.websiteName);
        setSchoolOrCollegeName(response.data.schoolOrCollegeName);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const handleAdd = async () => {
    setShowAddNewModal(true);
  };

  const handleEdit = async (studentId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/PersonalDetails/${studentId}`
      );
      console.log(response.data);
      //setEditItem(response.data);
      setEditItem({
        ...defaultHideFields,
        ...response.data,
        guardianFullName: response.data.guardianFullName ?? "",
        guardianContactNumber: response.data.guardianContactNumber ?? "",
        guardianEmail: response.data.guardianEmail ?? "",
        guardianOccupation: response.data.guardianOccupation ?? "",
        guardianAadhaarNo: response.data.guardianAadhaarNo ?? "",
        guardianHighestQualification:
          response.data.guardianHighestQualification ?? "",
      });
      setShowEditModal(true);
    } catch (error) {
      console.error("Error fetching item details", error);
    }
  };

  const handleView = async (studentId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/PersonalDetails/ReturnStudentDetails?studentId=${studentId}`
      );
      setStudentDetails(response.data);
      setShowDetailsModal(true);
    } catch (error) {
      console.error("Error fetching student details", error);
    }
  };

  const handleDocsView = async (studentId) => {
    try {
      setSelectedStudentId(studentId);
      setShowDocumentModal(true);
    } catch (error) {
      console.error("Error fetching student details", error);
    }
  };

  const handleonLCOLViewView = async (studentId) => {
    try {
      setSelectedStudentId(studentId);
      const response = await axios.get(`${baseUrl}/api/SchoolLeavingCertificate/${studentId}`);
      setSchoolLeavingCertificateData(response.data);
      setShowSLCModal(true);
    } catch (error) {
      console.error("Error fetching SLC data", error);
      setSchoolLeavingCertificateData(null);
      setShowSLCModal(true);
    }
  };

  const handleSLCSubmit = async (formData) => {
    try {
      const payload = {
        ...formData,
        studentId: selectedStudentId, // or however you're tracking the student
      };

      const response = await axios.post(
        `${baseUrl}/api/SchoolLeavingCertificate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("School Leaving Certificate saved successfully!");
        setShowSLCModal(false);
        fetchData(); // refresh list
      } else {
        toast.error("Failed to save School Leaving Certificate");
      }
    } catch (error) {
      console.error("SLC submit error", error);
      toast.error("Error submitting School Leaving Certificate");
    }
  };

  const handleOtherDetailsEdit = async (studentId, schoolId) => {
    try {
      setSelectedStudentId(studentId);
      setSchoolId(schoolId);
      setShowOtherDetailsModal(true);
    } catch (error) {
      console.error("Error fetching item details", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      editItem.UpdatedBy = localStorage.getItem("userID");
      await axios.put(
        `${baseUrl}/api/PersonalDetails/${editItem.studentId}`,
        editItem
      );
      toast.success("Details updated successfully!");
      setShowEditModal(false);
      fetchData();
    } catch (error) {
      console.error("Error updating details", error);
      toast.error(error?.response?.data);
    }
  };

  const handleDelete = async (studentId) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        await axios.delete(`${baseUrl}/api/PersonalDetails/${studentId}`);
        toast.success("Record deleted successfully!");
        fetchData();
      } catch (error) {
        console.error("Error deleting record", error);
        toast.error("Error deleting record.");
      }
    }
  };

  const getGreeting = () => {
    const hours = new Date().getHours();
    if (hours < 12) return "Good morning";
    if (hours < 17) return "Good afternoon";
    return "Good evening";
  };

  const handleNewStudentSubmit = (e) => {
    e.preventDefault();
    console.log(formData);

    const updatedFormData = {
      ...formData, // Spread the current formData fields
      schoolId: adminSelectedSchoolId, // Add or overwrite the schoolId field
      status: role === 'Admin' ? 'APPROVED' : 'PENDING'
    };

    axios
      .post(`${baseUrl}/api/PersonalDetails`, updatedFormData)
      .then((response) => {
        if (!response || !response.data) {
          throw new Error("Invalid response");
        }
        setShowAddNewModal(false);
        setFormData({
          firstName: "",
          middleName: "",
          lastName: "",
          gender: "",
          studentContactNumber: "",
          studentEmail: "",
          password: "",
          schoolId: adminSelectedSchoolId,
          schoolName: "",
          StandardId: "",
          SectionId: "",
        });

        fetchData();
        const greeting = getGreeting();
        // const whatsappMessage = `Dear *${formData.firstName} ${formData.middleName} ${formData.lastName}*, ${greeting}\n\n`
        //   + `We are pleased to inform you that your registration has been successfully completed and approved with ${schoolOrCollegeName}. \n\n`
        //   + `Here is your school portal login credentials:.\n\n`
        //   + `School Portal link: ${schoolWebsiteLink}.\n\n`
        //   + `Login Username: ${formData.studentEmail}.\n\n`
        //   + `Password: ${formData.password}.\n\n`
        //   + `Keynote: Please, do not share your login credentials to anyone as well as we request you to change default password once login in Manage profile section.`
        //   + `If you have any questions or need further assistance, please feel free to contact our support team at support@panaceaschool.in or call us at *123-456-7890*`;

        toast.success("Registration successful!");
      })
      .catch((error) => {
        if (error?.status === 400) {
          toast.error(error?.response?.data);
        }
        else {
          toast.error("Failed to register. Please try again.");
        }
      });
  };

  const handleDocumentSubmit = (files) => {

    console.log("Received files:", files);
    console.log("Student ID:", selectedStudentId);

    const formData = new FormData();
    formData.append("studentId", selectedStudentId);

    Object.entries(files).forEach(([key, file]) => {
      formData.append(key, file);
    });

    // Send formData to API
    axios.post("http://your-api-endpoint/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(response => console.log("Upload success", response))
      .catch(error => console.error("Upload error", error));
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSubmitOtherDetails = (e, OtherDetailsData) => {
    e.preventDefault();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data", // Ensure Content-Type is set
      },
    };
    axios
      .post(`${baseUrl}/api/StudentOtherDetails`, OtherDetailsData, config)
      .then((response) => {
        if (!response || !response.data) {
          throw new Error("Invalid response");
        }
        setShowOtherDetailsModal(false);
        fetchData();
        toast.success("Details saved successfully!");
      })
      .catch((error) => {
        toast.error("Failed to save. Please try again.");
      });
  };

  const handleUpdateStatus = (statusData) => {
    // Send statusData to the API or handle it as needed
    console.log("Status Update Data:", statusData);
    // Make an API request to update the student status here
    axios
      .put(`${baseUrl}/api/PersonalDetails/UpdateStudentStatus`, statusData)
      .then((response) => {
        if (response && response.status === 204) {
          toast.success("Status updated successfully.")
          fetchData();
        }
        // Handle success (e.g., show a success message or refresh data)
      })
      .catch((error) => {
        console.error("Error updating status", error);
        // Handle error (e.g., show an error message)
      });
  };

  const handleSearch = async (searchCriteria, searchValue) => {
    if (!searchValue) {
      fetchData();
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}/api/PersonalDetails/SearchStudentDetails`,
        {
          params: {
            searchCriteria,
            searchValue,
            loggedUser,
          },
        }
      );
      setData(response.data); // Set students data in state
      //setErrorMessage(""); // Reset any error messages
    } catch (error) {
      toast.error(
        error.response?.data || "Something went wrong while fetching data."
      );
      setData([]); // Clear the list in case of an error
    }
  };

  const handleInitialMessageAcknowledge = async () => {
    try {
      await axios.put(`${baseUrl}/api/PersonalDetails/UpdateInitialMessage/${studentId}`);
      setShowOneTimeModal(false);
      toast.success("Acknowledgement saved successfully!");
    } catch (error) {
      console.error("Failed to update initial message status", error);
      toast.error("Failed to update status.");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5 mb-5">
        <PersonalDetailsList
          data={data}
          onEdit={handleEdit}
          onView={handleView}
          onOtherDetailsEdit={handleOtherDetailsEdit}
          onDelete={handleDelete}
          onAddNewStudent={handleAdd}
          handleUpdateStatus={handleUpdateStatus}
          onDocsView={handleDocsView}
          onLCOLView={handleonLCOLViewView}
          handleSearch={handleSearch}
        />
        {showDocumentModal && (
          <DocumentMasterModal
            showhandleDocumentMaster={showDocumentModal}
            handleDocumentMasterClose={() => setShowDocumentModal(false)}
            handleSubmit={handleDocumentSubmit}
            studentId={selectedStudentId}
          />
        )}
        {showSLCModal && (
          <SchoolLeavingCertificateModal
            show={showSLCModal}
            handleClose={() => setShowSLCModal(false)}
            studentId={selectedStudentId}
            certificateData={schoolLeavingCertificateData}
            onSubmit={handleSLCSubmit}
          />
        )}
        {showAddNewModal && (
          <AddNewStudentModal
            showAddNew={showAddNewModal}
            handleCloseNewStudent={() => setShowAddNewModal(false)}
            handleNewStudentSubmit={handleNewStudentSubmit}
            newStudentItem={formData}
            setNewStudentItem={setFormData}
            adminSchoolId={adminSelectedSchoolId}
          />
        )}
        {showEditModal && (
          <EditPersonalDetailsModal
            show={showEditModal}
            handleClose={() => setShowEditModal(false)}
            handleSubmit={handleSubmit}
            editItem={editItem}
            setEditItem={setEditItem}
            adminSchoolId={adminSelectedSchoolId}
          />
        )}
        {showOtherDetailsEditModal && (
          <AddStudentOtherDetailsModal
            selectedStudentId={selectedStudentId}
            schoolId={schoolId}
            showOtherDetails={showOtherDetailsEditModal}
            handleCloseOtherDetails={() => setShowOtherDetailsModal(false)}
            handleSubmitOtherDetails={handleSubmitOtherDetails}
          />
        )}
        {showDetailsModal && (
          <StudentDetailsModal
            show={showDetailsModal}
            handleDetailsClose={() => setShowDetailsModal(false)}
            studentDetails={studentDetails}
          />
        )}
        {/* Bootstrap Modal */}
        {showModal && (
          <div
            className="modal fade show"
            style={{ display: "bloc k" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="successModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="successModalLabel">
                    Registration Successful
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <p dangerouslySetInnerHTML={{ __html: greetingMessage }} />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showOneTimeModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "30px",
                borderRadius: "10px",
                maxWidth: "500px",
                width: "90%",
                textAlign: "left",
                boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
              }}
            >
              <h4 style={{ marginBottom: "20px", fontWeight: "bold" }}>Important Notice</h4>
              <p style={{ marginBottom: "10px", lineHeight: "1.5" }}><strong>Dear Student,</strong></p>
              <p style={{ marginBottom: "10px", lineHeight: "1.5" }}>To avoid any discrepancies during the admission process, please ensure that you fill in all details in the registration form exactly as they appear in your Leaving Certificate (LC), Aadhaar Card, and other supporting documents.</p>
              <p style={{ marginBottom: "10px", lineHeight: "1.5" }}>After filling out the form, kindly click on "View" and take a printout of the completed form. Submit the printed form to the administration office for further processing of your admission.</p>
              <p style={{ marginBottom: "10px", lineHeight: "1.5" }}>Your cooperation is appreciated.</p>
              <button
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={handleInitialMessageAcknowledge}
              >
                I understand
              </button>
            </div>
          </div>
        )}

        <div
          className="modal-backdrop fade show"
          style={{ display: showModal ? "block" : "none" }}
        ></div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default PersonalDetailsPage;
